import html from './html';

const isLive = html.classList.contains('-live');

export default isLive;
